export const environment = {
  production: true,
  apiUrl: "https://cigaro.esrv.me/api/v1",
  //apiUrl: "https://cigaro.net/api"
};
